var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"}],ref:"vFecha",staticClass:"form-control",attrs:{"type":"text","placeholder":"dd/mm/yyyy","value":"vFecha"},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }